<script lang="ts">
    //import {ASSET_URL} from "../config";
    import { fade,slide } from 'svelte/transition';

    import {ASSET_URL} from "../../config";

    export let text="";
    let showOverlay = false;
    export let overlayText = "";

    export let withoutOverlay = false;


    function toggleOverlay() {

        showOverlay = !showOverlay;
    }

</script>
<div class="upload-info-box" class:active={showOverlay}>
    {#if !showOverlay}
    <slot>
        <span class="text-content"  in:fade={{ duration: 100, delay:0 }}>{text}</span>
    </slot>
    {/if}
    {#if !withoutOverlay}
        <div class="overlay-icon-wrapper">

           <span class="overlay-icon" class:active={showOverlay} on:click={toggleOverlay}>

               {#if showOverlay}
                  <div><img src="{ASSET_URL}/assets/img/icons/close-white.svg"/></div>
               {:else}
                  <div><img src="{ASSET_URL}/assets/img/icons/questionmark.svg"/></div>
                 {/if}
           </span>
        </div>
    {/if}

    {#if showOverlay}
        <div class="overlay-content" in:fade={{ delay:0, duration: 500 }} out:fade={{delay:0, duration:0}}  >
            <slot name="overlayText">
                {overlayText}
            </slot>
        </div>
    {/if}
</div>


<style lang="scss">

  .text-content, .overlay-content {

    display: flex;
    padding: 12px;
    padding-right: 15%;


  }

  .text-content{
    background: $form-item-bg;
    color: $white!important;
  }

  .upload-info-box {

    padding:0;

    color: $white;
    //color: #F8F7F7;

    border-radius: 9px;
    position: relative;
    min-height: 20px;
    overflow: hidden;
    //transition: max-height 3s ease-out;
    //max-height: 0; /* Start collapsed */
    // padding-top:12px;

    &.active{

      //max-height: 500px;

      .text-content{

//        display: none;

      }
    }

  }

  .overlay-icon-wrapper {
    position: absolute;
    right: 12px;
    top: 12px;
    z-index: 100;

  }


  .overlay-icon {

    background: $white;
    border-radius: 50%;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    //wp fix:
    width:24px;
    height:24px;
    /*
    width: 12px;
    height: 12px;

     */
    transition: all .2s ease-in-out;

    &:hover {
      cursor:pointer;
      transform: scale(1.1);
    }

    div {
      width: 12px;
      height: 12px;
    }

    img {
      width: 100%;
      height: 100%;
    }

    &.active {
      background: $secondary-color;

    }
  }

  .overlay-content {
      background: $white;
      //background: $white;
      color: $primary-color;
      z-index: 99;


    /*
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

     */
    //padding: 12px;
    //padding-right: 50px;

  }


</style>
